@if (productData && hasValidTranslations) {
<section class="section-2 mt-4 pt-4 mb-6 mb-lg-7">
    @for (heading of groupedContent['SECTION-2']; track heading) { @if
    (heading.headingText || heading.descriptionText) {
    <div class="container text-center mb-4">
        <div class="col-12 col-xl-10 offset-xl-1">
            @if (heading.headingText) {
            <h2 [innerHTML]="heading.headingText" class="text-blue-300"></h2>
            } @if (heading.descriptionText) {
            <div [innerHTML]="heading.descriptionText"></div>
            }
        </div>
    </div>
    } } @for (inlineBannerKeys of groupedContent['SECTION-2_INLINE-BANNER'];
    track inlineBannerKeys; let i = $index; let odd = $odd) { @if (
    inlineBannerKeys.buttonText || inlineBannerKeys.buttonUrl ||
    inlineBannerKeys.descriptionText || inlineBannerKeys.headingText ||
    inlineBannerKeys.desktopImageUrl || inlineBannerKeys.tabletImageUrl ||
    inlineBannerKeys.mobileImageUrl || inlineBannerKeys.imageAltText ||
    inlineBannerKeys.tabletImageAltText || inlineBannerKeys.mobileImageAltText
    || inlineBannerKeys.linkText || inlineBannerKeys.linkUrl ||
    inlineBannerKeys.videoId ) {
    <div class="mb-3 mb-sm-4 mb-md-5 mb-lg-6">
        <div class="container">
            <vision2-inline-banner
                [backgroundImage]="inlineBannerKeys.desktopImageUrl"
                [backgroundImageTablet]="inlineBannerKeys.tabletImageUrl"
                [backgroundImageMobile]="inlineBannerKeys.mobileImageUrl"
                [backgroundImageAltText]="inlineBannerKeys.imageAltText"
                [backgroundImageTabletAltText]="
                    inlineBannerKeys.tabletImageAltText
                "
                [backgroundImageMobileAltText]="
                    inlineBannerKeys.mobileImageAltText
                "
                [buttonText]="inlineBannerKeys.buttonText"
                [buttonUrl]="inlineBannerKeys.buttonUrl"
                [colorClass]="'text-bg-gray-20'"
                [description]="inlineBannerKeys.descriptionText"
                [heading]="inlineBannerKeys.headingText"
                [headingValue]="2"
                [linkText]="inlineBannerKeys.linkText"
                [linkUrl]="inlineBannerKeys.linkUrl"
                [type]="odd ? 'right' : 'left'"
                [modalVideoId]="inlineBannerKeys.videoId"
            >
            </vision2-inline-banner>
        </div>
    </div>
    } } @if (groupedContent['SECTION-2_CONTENT-BLOCK'] &&
    groupedContent['SECTION-2_CONTENT-BLOCK'].length > 0) {
    <div class="container">
        <div class="row justify-content-center">
            @for (contentBlockKeys of groupedContent['SECTION-2_CONTENT-BLOCK'];
            track contentBlockKeys; let i = $index) { @if (
            contentBlockKeys.buttonText || contentBlockKeys.buttonUrl ||
            contentBlockKeys.descriptionText || contentBlockKeys.headingText ||
            contentBlockKeys.imageUrl || contentBlockKeys.imageAltText ||
            contentBlockKeys.linkText || contentBlockKeys.linkUrl ||
            contentBlockKeys.videoId ) {
            <div
                class="col-12 col-sm-10 col-md-6 col-xl-5 pb-0 px-0 card-container"
            >
                <vision2-card
                    [buttonText]="contentBlockKeys.buttonText"
                    [buttonUrl]="contentBlockKeys.buttonUrl"
                    [description]="contentBlockKeys.descriptionText"
                    [image]="contentBlockKeys.imageUrl"
                    [imageAlt]="contentBlockKeys.imageAltText"
                    [imageClass]="'rounded-4 w-100 mb-3'"
                    [imageSizes]="
                        '(min-width: 1440px) 42vw, (min-width: 768px) 50vw, (min-width: 575px) 84vw, 100vw'
                    "
                    [linkUrl]="contentBlockKeys.linkUrl"
                    [linkText]="contentBlockKeys.linkText"
                    [modalVideoId]="contentBlockKeys.videoId"
                    [title]="contentBlockKeys.headingText"
                    [cardClass]="
                        'pt-3 pt-md-4 px-2 mx-auto text-center text-bg-light'
                    "
                    [cardColor]="'bg-transparent'"
                >
                </vision2-card>
            </div>
            } }
        </div>
    </div>
    } @for (sideBySideKeys of groupedContent['SECTION-2_SIDE-BY-SIDE']; track
    sideBySideKeys; let i = $index; let odd = $odd) { @if (
    sideBySideKeys.buttonText || sideBySideKeys.buttonUrl ||
    sideBySideKeys.descriptionText || sideBySideKeys.headingText ||
    sideBySideKeys.imageUrl || sideBySideKeys.imageAltText ||
    sideBySideKeys.linkText || sideBySideKeys.linkUrl || sideBySideKeys.videoId
    ) {
    <div class="container">
        <vision2-side-by-side
            [buttonText]="sideBySideKeys.buttonText"
            [buttonUrl]="sideBySideKeys.buttonUrl"
            [description]="sideBySideKeys.descriptionText"
            [headingValue]="2"
            [image]="sideBySideKeys.imageUrl"
            [imageAlt]="sideBySideKeys.imageAltText"
            [linkUrl]="sideBySideKeys.linkUrl"
            [linkText]="sideBySideKeys.linkText"
            [modalVideoId]="sideBySideKeys.videoId"
            [heading]="sideBySideKeys.headingText"
            [roundedImage]="'rounded-4'"
            [type]="odd ? 'left' : 'right'"
            buttonClass="btn-primary"
            [containerType]="'container-xl col-sm-10 col-lg-12'"
            [contentClass]="
                odd
                    ? 'col-lg-6 col-xl-5 offset-xl-1 text-bg-light bg-transparent'
                    : 'col-lg-6 col-xl-5 text-bg-light bg-transparent'
            "
            [contentPadding]="
                odd ? 'pt-2 pt-md-4 pt-xl-6' : 'pt-2 pt-md-4 pt-xl-6'
            "
            [imageClass]="odd ? 'col-lg-6' : 'col-lg-6 offset-xl-1 '"
        >
        </vision2-side-by-side>
    </div>
    } }
</section>
}
